/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-12-09 18:35:56
 * @LastEditors: voanit
 * @LastEditTime: 2021-12-10 14:25:38
 */
export default [
    {
        path: '/sales-analysis',
        name: 'sales-analysis',
        meta: {
            name: '售后分析',
            keepAlive: true,
            notLayout: true
        },
        redirect: { name: 'work-order' }
    },
    {
        path: '/work-order',
        name: 'work-order',
        meta: {
            name: '工单概览',
            keepAlive: true,
            notLayout: true
        },
        component:() => import(/* webpackChunkName: "analysis" */ '@/views/sales-analysis/work-order/index.vue')
    },
    {
        path: '/sale-order',
        name: 'sale-order',
        meta: {
            name: '退货概览',
            keepAlive: true,
            notLayout: true
        },
        component:() => import(/* webpackChunkName: "analysis" */ '@/views/sales-analysis/sale-order/index.vue')
    },
    {
        path: '/order-link',
        name: 'order-link',
        meta: {
            name: '订单全链路',
            keepAlive: true,
            notLayout: true
        },
        component:() => import(/* webpackChunkName: "analysis" */ '@/views/sales-analysis/order-link/index.vue')
    }
]
